export class HubSpotService {
    static $inject = ['HUBSPOT_SUBMIT_FORMS_URL', 'HUBSPOT_PORTAL_ID', '$http'];
    constructor(HUBSPOT_SUBMIT_FORMS_URL, HUBSPOT_PORTAL_ID, $http) {
        'ngInject';
        this.HUBSPOT_SUBMIT_FORMS_URL = HUBSPOT_SUBMIT_FORMS_URL;
        this.HUBSPOT_PORTAL_ID = HUBSPOT_PORTAL_ID;
        this.$http = $http;
        this.buildHubspotFormUrl = (formId) => `${this.HUBSPOT_SUBMIT_FORMS_URL}/${this.HUBSPOT_PORTAL_ID}/${formId}`;
    }
    async submitForm(fields, formId) {
        return await this.$http({
            method: 'POST',
            url: this.buildHubspotFormUrl(formId),
            data: { fields },
        });
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
HubSpotService.$inject = ['HUBSPOT_SUBMIT_FORMS_URL', 'HUBSPOT_PORTAL_ID', '$http'];
